import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { FormsModule } from '@angular/forms';

import { IonicModule } from '@ionic/angular';
import { TranslateModule } from '@ngx-translate/core';

import { SeasonSelectorComponent } from './season-selector.component';

@NgModule({
    imports: [
        CommonModule,
        FormsModule,
        IonicModule,
        TranslateModule.forChild(),
    ],
    declarations: [
        SeasonSelectorComponent
    ],
    exports: [
        SeasonSelectorComponent
    ]
})
export class SeasonSelectorModule { }
